module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "addDeduction",
    attrs: {
      "hide-footer": "",
      "title": "Dodaj"
    },
    on: {
      "hidden": _vm.onDeductionModalHidden,
      "shown": _vm.setupModalData
    }
  }, [(_vm.debtorFormLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.debtorFormLoading) ? _c('form-deduction', {
    ref: "addDeductionForm",
    attrs: {
      "currencyName": _vm.currencyName,
      "handleSubmit": _vm.handleDeductionSubmit,
      "values": _vm.deductionData,
      "errors": _vm.deductionViolations,
      "typeSelection": _vm.typeSelection,
      "amountFromTransfer": _vm.amountFromTransfer
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.debtorFormLoading) ? _c('b-row', [_c('b-col', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "block": ""
    },
    on: {
      "click": _vm.hideDeductionModal
    }
  }, [_c('span', [_vm._v("Anuluj")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "default",
      "block": ""
    },
    on: {
      "click": _vm.sendDeductionForm
    }
  }, [_c('span', [_vm._v("Zapisz")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "tick"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.createdDeductionMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Potrącenie w kwocie " + _vm._s(_vm.createdDeductionMessage) + " zostało dodane")]) : _vm._e(), _vm._v(" "), (_vm.deleteDeductionMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Potrącenie w kwocie " + _vm._s(_vm.deleteDeductionMessage) + " zostało usunięte")]) : _vm._e(), _vm._v(" "), (_vm.deductionListLoading || _vm.deductionDeleteLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.deductionListLoading && !_vm.deductionDeleteLoading) ? _c('b-row', {
    attrs: {
      "align-h": "start"
    }
  }, [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showDeductionModal('advance-deduction')
      }
    }
  }, [_c('span', [_vm._v("Dodaj zaliczkę/potrącenie")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showDeductionModal('refund')
      }
    }
  }, [_c('span', [_vm._v("Dodaj zwrot")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.deductionListLoading && !_vm.deductionDeleteLoading) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Opis")]), _vm._v(" "), _c('th', [_vm._v("Uwagi")]), _vm._v(" "), _c('th', [_vm._v("Kwota (" + _vm._s(_vm.currencyName) + ")")]), _vm._v(" "), (!_vm.amountFromTransfer) ? _c('th', [_vm._v("Rozliczenie")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deductionListItems), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item.comments))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), (!_vm.amountFromTransfer) ? _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(_vm._f("translate")(item.settlementType)))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "td-no_link no-wrap"
    }, [_vm._v(_vm._s(_vm._f("date")(item.deductionDate)))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon btn-icon--warning",
      attrs: {
        "href": "#",
        "title": "Usuń"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteDeduction(item)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "minus"
      }
    })], 1)])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bdbd7b76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/UpdateDeduction.vue
// module id = 843
// module chunks = 0